import { render, staticRenderFns } from "./DealerBanner.vue?vue&type=template&id=735b4d54"
import script from "./DealerBanner.vue?vue&type=script&lang=ts"
export * from "./DealerBanner.vue?vue&type=script&lang=ts"
import style0 from "./DealerBanner.vue?vue&type=style&index=0&id=735b4d54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
